<template>
  <div class="page-view box-card">

    <div class="box-card-header">
      <router-link class="kg-btn1" :to="{ name: 'publicWithdrawalRecord' }">
        <I18Lang id="my45" defaultText="出金记录" />
      </router-link>
    </div>

    <div class="box-card-content">
      <div class="account-info">
        <el-form :model="formData" ref="formData" class="reset-from" :rules="rules">

          <div class="left">

            <div class="form-item">
              <div class="form-item-label">
                <I18Lang id="my46" defaultText="现金账户余额" />（MEQ）
              </div>
              <div class="form-item-value">{{ withdrawalInfo.balance }}</div>
            </div>

            <el-form-item label="出金金额($)" prop="amount">
              <template slot="label">
                <I18Lang id="my112" defaultText="出金金额($)" />
              </template>
              <el-input type="number" @input="inputNum" v-model="formData.amount" class="reset-input"
                :placeholder="$t('my49')"></el-input>
              <p class="rate-text">
                <I18Lang id="public81" defaultText="当前USDT汇率" /> {{ withdrawalInfo.exchange_rate }}
              </p>
            </el-form-item>

            <div class="form-item">
              <div class="form-item-label">
                <I18Lang id="my155" defaultText="Tether（USDT）" />
              </div>
              <div class="form-item-value">{{ usdMoney }}</div>
            </div>
            <el-form-item label="">
              <el-radio-group v-model="formData.address_type">
                <el-radio v-for="(item, idx) in withdrawalInfo.address_types" :key="idx" :label="item.name">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('user113')" prop="address">
              <el-input v-model="formData.address" class="reset-input" :placeholder="$t('text5')"></el-input>
            </el-form-item>

            <el-form-item prop="code" :label="$t('user55')">
              <el-input type="password" show-password name="code" autocomplete="off" auto-complete="off" v-model="formData.code"
                :placeholder="$t('user126')">
              </el-input>
            </el-form-item>

            <el-form-item>
              <div :loading="isSubmitLoading" class="btn-submit kg-btn2" @click="submitForm('formData')">
                <I18Lang id="my22" defaultText="立即提交" />
              </div>
            </el-form-item>

          </div>

          <div class="bank-info" v-if="withdrawalInfo.bank_info">
            <div class="bank-info-title">
              <I18Lang id="my52" defaultText="到账银行" />
            </div>
            <div class="bank-card">
              <span class="bank-name">{{ withdrawalInfo.bank_info.bank_name }}</span>
              <div class="bank-address">{{ withdrawalInfo.bank_info.bank_user }} {{ withdrawalInfo.bank_info.bank_no }}
              </div>
            </div>
          </div>

        </el-form>
      </div>

    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'home',
  data () {
    const validate = (rule, value, callback) => {
      if (Number(value || 0) > Number(this.withdrawalInfo.balance || 0)) {
        callback(new Error('The withdrawal amount is incorrect, please re-enter'))
      } else {
        callback()
      }
    }

    return {
      isSendCode: false,
      isSubmitLoading: false,
      withdrawalInfo: {},
      sendLoading: false,
      formData: {
        amount: '',
        exchange_rate: '',
        address_type: '',
        address: '',
        code: ''
      },
      rules: {
        amount: { required: true, validator: validate, trigger: 'blur' }
      },
      rate: 0
    }
  },
  created () {
    this.getWithdrawalInfo()
  },
  methods: {
    inputNum () {
      // eslint-disable-next-line no-useless-escape
      this.formData.amount = this.formData.amount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    getWithdrawalInfo () {
      this.$http.post('/api/cash/withdrawalInfo').then(result => {
        this.withdrawalInfo = result
        this.formData.exchange_rate = result.exchange_rate
        if (result && result.address_types) {
          this.formData.address_type = result.address_types[0].name
        }
      })
    },
    getBit (value, bit = 3) {
      let str = value.toString()
      const strIndex = str.indexOf('.')
      if (strIndex === -1) return str
      str = str.substring(0, strIndex + bit)
      return str
    },
    isNumber (value) { // 验证是否为数字
      var patrn = /^(-)?\d+(\.\d+)?$/
      if (patrn.exec(value) == null || value === '') {
        return false
      } else {
        return true
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData()
        }
      })
    },
    submitSendEmailAuthCode () {
      console.log('this.userInfo', this.userInfo)
      const params = {
        email: this.userInfo.email,
        event: 'recharge'
      }
      this.sendLoading = true
      this.$http
        .post(this.userInfo.verify_email ? '/api/email/send' : '/api/sms/send', params, { direct: true })
        .then((result) => {
          if (result.code === 200) {
            this.isSendCode = true
            this.sendLoading = false
          } else {
            this.$message.error(result.msg)
          }
        })
        .catch(() => {
          this.sendLoading = false
        })
    },
    submitData () {
      if (this.formData.amount < 0 || this.formData.amount === 0 || !this.formData.amount) {
        this.$alert(this.$t('public30'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: action => {
          }
        })
        return false
      }
      if (!String(this.formData.code || '').trim()) {
        this.$alert(this.$t('user126'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: action => {
          }
        })
        return false
      }
      this.isSubmitLoading = true
      this.$http.post('/api/cash/withdrawal', this.formData).then(result => {
        this.$alert(`<h3>${this.$t('my53')}</h3><p>${this.$t('my54')}</p>`, '', {
          confirmButtonText: this.$t('my25'),
          center: true,
          dangerouslyUseHTMLString: true,
          customClass: 'success-alert',
          callback: action => {
            this.$router.push({ name: 'publicWithdrawalRecord' })
          }
        })
      }).finally(() => {
        this.isSubmitLoading = false
      })
    }
  },
  computed: {
    usdMoney () {
      if (!this.withdrawalInfo.exchange_rate || !this.formData.amount) {
        return 0
      }
      const val = this.withdrawalInfo.exchange_rate * this.formData.amount
      return this.getBit(val, 5)
    },
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
.page-view {
  padding-top: 50px;
  padding-bottom: 100px;

  .box-card-header {
    width: 936px;
    margin: 0 auto;
    display: flex;
    justify-content: end;

    .kg-btn1 {
      width: 188px;
      margin-right: -6px;
      margin-bottom: 3px;
    }
  }

  .box-card-content {
    background: url('../../../assets/img/k.png') no-repeat center / 100% 100%;
    width: 936px;
    height: 860px;
    margin: 0 auto;

    .reset-from {
      display: flex;

      .left {
        padding-top: 93px;
        padding-left: 95px;
        padding-right: 95px;
      }

      .bank-info {
        position: relative;
        margin-top: 86px;

        .bank-info-title {
          font-size: 14px;
          font-weight: 400;
          color: #01B2F5;
          margin-bottom: 17px;
        }

        .bank-card {
          width: 320px;
          height: 160px;
          background: url('../../../assets/img/bank-info-bg2.png') no-repeat center / 100%;

          .bank-name {
            font-size: 20px;
            font-weight: 400;
            color: #FFFFFF;
            padding-left: 60px;
            display: block;
            padding-top: 15px;
          }

          .bank-address {
            font-size: 16px;
            font-family: Arial;
            font-weight: 400;
            color: #FFFFFF;
            padding-top: 30px;
            padding-left: 28px;
          }

        }

      }

      .input-tips {
        display: inline-block;
        padding: 0 10px;
        height: 19px;
        background: rgb(#000, 0.3);
        margin-top: 4px;
        border: none;
        border-radius: 0;
        font-size: 12px;
        font-family: Arial;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 19px;
        text-align: center;
      }

      .form-item {
        margin-bottom: 35px;

        .form-item-label {
          font-size: 16px;
          font-weight: 400;
          color: #01B2F5;
        }

        .form-item-value {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
        }
      }

      ::v-deep .el-form-item {
        margin-bottom: 40px;

        .el-form-item__label {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #01B2F5;
        }

        .el-input__inner {
          width: 319px;
          height: 34px;
          border: 1px solid rgba(1, 178, 245, 0.5);
          line-height: 34px;
          background: transparent;
          color: #fff;
          border-radius: 0;
        }

        .el-radio__inner {
          background: #000;
          width: 20px;
          height: 20px;
          border: 1px solid rgba(1, 178, 245, 0.5);
        }

        .el-radio__label {
          color: #fff;
        }

        .el-radio__input.is-checked .el-radio__inner {
          border: 4px solid #01b2f5;

          &::after {
            display: none;
          }
        }

      }

      .reset-input-code {
        ::v-deep {
          .el-input__inner {
            width: 100%;
            border-right: none;
            padding-right: 0;
          }

          .el-input-group__append {
            background: transparent;
            border: 1px solid rgba(1, 178, 245, 0.5);
            border-left: none;
            border-radius: 0;

            .btn {
              color: #01B2F5;
            }
          }
        }
      }

      .btn-submit {
        width: 110px;
        height: 55px;
        line-height: 55px;
        margin-left: -10px;
      }
    }
  }
}

.rate-text {
  padding-top: 12px;
  padding-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #C9C9C9;
  line-height: 15px;

  i {
    font-size: 14px;
    font-weight: bold;
    color: #01B2F5;
  }
}

.btn-copy {
  display: inline-block;
  margin-left: 10px;
  text-decoration: underline;
  cursor: pointer;
}

@media only screen and (max-width: 755px) {
  .page-view {
    padding-top: 50px;
    padding-bottom: 100px;

    .box-card-header {
      width: auto;
      margin: 0 auto;
      display: flex;
      justify-content: end;

      .kg-btn1 {
        width: 238px;
        margin-right: -6px;
        margin-bottom: 3px;
      }
    }

    .box-card-content {
      background: none;
      width: auto;
      height: auto;
      margin: 0 auto;

      .reset-from {
        display: flex;

        .left {
          padding-top: 0;
          padding-left: 0;
          padding-right: 20px;
        }

        .bank-info {
          position: relative;
          margin-top: 86px;

          .bank-info-title {
            font-size: 20px;
            font-weight: 400;
            color: #01B2F5;
            margin-bottom: 17px;
          }

          .bank-card {
            width: 320px;
            height: 160px;
            background: url('../../../assets/img/bank-info-bg2.png') no-repeat center / 100%;

            .bank-name {
              font-size: 20px;
              font-weight: 400;
              color: #FFFFFF;
              padding-left: 60px;
              display: block;
              padding-top: 15px;
            }

            .bank-address {
              font-size: 20px;
              font-family: Arial;
              font-weight: 400;
              color: #FFFFFF;
              padding-top: 30px;
              padding-left: 28px;
            }

          }

        }

        .form-item {
          margin-bottom: 35px;

          .form-item-label {
            font-size: 20px;
            font-weight: 400;
            color: #01B2F5;
          }

          .form-item-value {
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
          }
        }

        ::v-deep .el-form-item {
          margin-bottom: 40px;

          .el-form-item__label {
            font-size: 20px;
            font-family: Arial;
            font-weight: 400;
            color: #01B2F5;
          }

          .el-input__inner {
            width: 329px;
            height: 60px;
            font-size: 18px;
            border: 1px solid rgba(1, 178, 245, 0.5);
            line-height: 60px;
            background: transparent;
            color: #fff;
            border-radius: 0;
          }

          .el-form-item__error {
            font-size: 16px;
          }
        }

        .btn-submit {
          width: 210px;
          height: 85px;
          line-height: 85px;
          font-size: 20px;
          margin-left: -10px;
        }
      }
    }
  }
}
</style>
